import { render, staticRenderFns } from "./OverviewView.vue?vue&type=template&id=328b523c&scoped=true&"
import script from "./OverviewView.vue?vue&type=script&lang=js&"
export * from "./OverviewView.vue?vue&type=script&lang=js&"
import style0 from "./OverviewView.vue?vue&type=style&index=0&id=328b523c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328b523c",
  null
  
)

export default component.exports